import { useQuery } from '@tanstack/react-query';
import { feedbackService } from '@/services/feedbackService';

export function useTripFeedback(tripId) {
  return useQuery({
    queryKey: ['tripFeedback', tripId],
    queryFn: async () => {
      const result = await feedbackService.getTripFeedback(tripId);
      if (!result.success) throw new Error(result.error);
      return { feedback: result.feedback };
    },
    enabled: !!tripId,
  });
}

export function useFeedbackQuestions() {
  return useQuery({
    queryKey: ['feedbackQuestions'],
    queryFn: async () => {
      const result = await feedbackService.getQuestions();
      if (!result.success) throw new Error(result.error);
      return { questions: result.questions };
    },
    staleTime: Infinity,
  });
}
